import textBodyMStrong from '@fukku/styles/texts/textBodyMStrong.module.css'
import { cx } from 'classix'
import type { ReactNode } from 'react'
import { TEST_IDS } from '../../constants/testIds'
import type { CreateComponentsConfig } from '../../types'

interface BoldProps {
	readonly children: ReactNode
	readonly customProps?: CreateComponentsConfig['boldProps']
}

/** Renders a bold element with literal text content */
export const Bold = ({ children, customProps }: BoldProps) => {
	const extraProps = {
		className: cx(textBodyMStrong.className, customProps?.className),
		...customProps,
	}

	return (
		<span data-testid={TEST_IDS.BOLD} {...extraProps}>
			{children}
		</span>
	)
}
